import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import HeaderRegionGames from 'js/containers/header-region/HeaderRegion.games';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';
import CtaPageBlocks from 'js/components/cta/CTA.page-blocks';

import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';
import { getAllGames } from 'js/store/games/Games.selectors';

const PageGames = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.games]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.games);
  });

  const games = useSelector((state) => getAllGames(state));

  useEffect(() => {
    trackPageview({ title: PAGE_IDS.games, path: props.path });
  }, []);

  const {
    header: {
      title = 'Games',
      description = 'Explore every episode of Stan & Gran, discover the characters and wildlife featured in each, and learn fun facts.',
      image = '',
    } = {},
    games_grid: { title: ctaTitle = 'Choose a game' } = {},
  } = pageData;

  const gameCtas = {
    content: games.map((game) => ({
      image: game.cta_image || game.header_image || game.game_seo?.image || game.default_image,
      link: {
        text: game.name || game.game_title,
        link_type: 'internal_page',
        page: `games/${game.friendly_url}`,
      },
    })),
  };

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionGames title={title} description={description} image={image} />
      <div className="game--content-grid" style={{ paddingBottom: '80px' }}>
        <SvgTextureLineLong color={'#3996FF'} />
        <div className="container">
          <div className="game--cta-block">
            <h2>{ctaTitle}</h2>
            <CtaPageBlocks ctas={gameCtas} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PageGames;
